import { useMutation } from "react-query";
import { updateUser } from "../../mutations/users/updateUser";
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { ReplaceEmployeeFormValuesType } from "../../pages/employees/EmployeeDetails/TabContentPages/EmployeePersonalDetails";
import { useConfig } from "../../utils/useConfig";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useData } from "../../utils/useData";
import { Employee } from "../../models";
import { toast } from "react-toastify";

export const useUpdateUser = (options?: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employerId, employer, employees, accounts } = useData();

    return useMutation(async (
        {values, employee}: 
        {values: ReplaceEmployeeFormValuesType, employee: Employee}
    ) => {

        const countryId: any = employer?.data?.country?.id;

        const { API_URL, token } = await getSafeSessionConfig(config, getToken);
        await updateUser(API_URL, token, employerId, employee   , values, countryId);
    },
    {
        onSuccess: () => {
            toast.success("User updated successfully");
            employees.refetch();
            accounts.refetch();
            options?.onSuccess?.();
            },
        onError: (error: Error) => {
            options?.onError?.(error);
        }
    })
}